import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box } from '@mui/material';
import { usePlanContext } from './context/planContext';

interface ZipCodeDialogProps {
  open: boolean;
  zipCode: string;
  onClose: () => void;
  onSave: (newZipCode: string) => void;
}

export default function ZipCodeDialog({ open, zipCode, onClose, onSave }: ZipCodeDialogProps) {
  const [tempZipCode, setTempZipCode] = React.useState('');
  const { setCompareData, saveZipToStorage } = usePlanContext();
  React.useEffect(() => {
    if (open) {setTempZipCode(zipCode);}
  }, [open, zipCode]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 5);
    setTempZipCode(value);
  };
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSave();
    }
  };
  const handleSave = () => {
    if (tempZipCode.length === 5 && /^\d+$/.test(tempZipCode)) {
      setCompareData([]); // Reset comparison data on ZIP code change
      saveZipToStorage(tempZipCode); // Save changed zip to cookies (if OneTrust consent granted)
      onSave(tempZipCode);
    }
  };
  const handleClose = () => {
    setTempZipCode(zipCode);
    onClose();
  };
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontFamily: 'Inter', fontSize: "1.5rem", color: "#2372b9", fontWeight: 400, }}>
        Update ZIP Code
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            autoFocus
            fullWidth
            label="ZIP Code"
            value={tempZipCode}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            placeholder="Enter 5-digit ZIP code"
            inputProps={{ maxLength: 5, inputMode: 'numeric' }}
            error={tempZipCode.length > 0 && tempZipCode.length !== 5}
            helperText={tempZipCode.length > 0 && tempZipCode.length !== 5 ? 'ZIP code must be 5 digits' : ''}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button onClick={handleClose} sx={{ color: '#6B7280', textTransform: 'none' }}>
          Cancel
        </Button>
        <Button  onClick={handleSave}  variant="contained"  disabled={tempZipCode.length !== 5}
          sx={{ textTransform: 'none', bgcolor: '#2372B9', '&:hover': { bgcolor: '#1d5a94' }}} >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
}
